export enum OrderByType {
  ascend = 'ASC',
  descend = 'DESC',
}
